import { useState, useEffect, useRef } from "react";
import MobileImageSlider from "../components/imagegallery/MobileImageSlider";
import "./digi.css";
import { toast } from "react-toastify";
import AttributesTable from "../components/list/AttributesTable";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../utils/axiosInstance";
import Collapse from "../components/accordion/Collapse";

import LinearLayout from "../components/layout/LinearLayout";

import BreadCrumb from "../components/breadcrumb/BreadCrumb";
import RatingBar from "../components/ratingbar/RatingBar";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import Footer from "../containers/Footer/Footer";
import ProductRecyclerview from "../components/layout/ScrollView/ProductRecyclerview";
import useDynamicTabTitle from "../useDynamicTabTitle";
const MobileProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  const [scrollY, setScrollY] = useState(0);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const sheetRef = useRef(null);
  const handleSelectProduct = (product) => navigate(`/product/${product._id}`);
  useDynamicTabTitle(product ? product.title : "Loading...");
  // 📦 دریافت محصول
  useEffect(() => {
      try {
    if (!id) return;
    axios.get(`/products/${id}`).then((res) => {
      if (res.data?.status) {
        setProduct(res.data.data);
        // console.log("brand",res.data.data.brand?.name);
        axios
          .get(`/categories/${res.data.data.categoryId._id}/path`)
          .then((r) => setBreadcrumbs(r.data));
      }
      setLoading(false);
    });

    axios.get(`/products/${id}/related`).then((res) => {
      if (res.data.status) setRelatedProducts(res.data.data);
    });
   } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error loading data!");
    } finally {
      setLoading(false);
    }
  }, [id]);

  const getdiscount = (price, discount) => {
    const newprice = Number(price) - (Number(price) * Number(discount)) / 100;
    return newprice;
  };
  const addToCart = async (productId, quantity = 1) => {
    try {
      const res = await axios.post("/cart/add", { productId, quantity });
      if (res.data.status)
        toast.success("محصول با موفقیت به سبد خرید اضافه شد 🛒");
      else toast.error("خطا در افزودن به سبد خرید");
    } catch (err) {
      toast.error(err.response?.data?.message || "مشکلی پیش آمد");
    }
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % product?.images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [product?.images.length]);
  // const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const prev = () =>
    setIndex((i) => (i - 1 + product?.images.length) % product?.images.length);
  const next = () => setIndex((i) => (i + 1) % product?.images.length);

  const fmt = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (loading) return <div className="p-3">Loading...</div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;
  // if (!product) return <div className="text-center p-5">Product not found</div>;
  return (
    <>
   <div className="product-details-page">
        <Toolbar />
        {/* اسلایدر */}
        <MobileImageSlider images={product?.images} />
        {/* محتوا */}

        <div className="product-content container">
          <div className="features-card ps-1">
            <BreadCrumb breadcrumbs={breadcrumbs} size="10px" />
            <div className="product-title ms-2 ">{product?.title}</div>
            <div className="text-muted small m-2">{product?.brand?.name}</div>
            <RatingBar margin={"1"} size={"6"} value={4.5} />
          </div>
          <LinearLayout margin={3}>
            <h5>Related Product</h5>
            <ProductRecyclerview
              items={relatedProducts}
              onItemClick={handleSelectProduct}
            />
          </LinearLayout>
          <Collapse title="Description">
            <p>{product?.description}</p>
          </Collapse>
          <Collapse title="Specifications">
            <AttributesTable attributes={product?.attributes} />
          </Collapse>
        
        {/* <Collapse title="رنگ‌ها">
          <div className="d-flex gap-2">
            {product.colors.map((c, i) => (
              <div
                key={i}
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 14,
                  background: c,
                  border: "1px solid #ddd",
                }}
              ></div>
            ))}
          </div>
        </Collapse> */}
      </div>

      {/* نوار خرید */}

      <LinearLayout
        className="buy-bar"
        ygravity="center"
        orientation="horizontal"
      >
        <button
          className="btn btn-sm bg-primary ms-1"
          onClick={(e) => {
            e.stopPropagation();
            addToCart(product._id || product.id);
          }}
          style={{ fontSize: "14px" }}
        >
          Add To Cart
        </button>
        <LinearLayout orientation="vertical">
          <LinearLayout
            className="ms-3 mt-1"
            gap={2}
            margin={0}
            ygravity="center"
            orientation="horizontal"
          >
            <h5
              className="text-danger mt-1 fw-bold text-decoration-line-through"
              style={{ fontSize: "14px" }}
            >
              {product?.price.toLocaleString()}${" "}
            </h5>
            <h5
              className="text-danger mt-1 fw-bold"
              style={{ fontSize: "14px" }}
            >
              {" - "}
              {getdiscount(product?.price, product?.discount)}$
            </h5>
            {product?.discount > 0 && (
              <span
                style={{
                  background: "#ffccd5",
                  color: "#e60023",
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              >
                {product?.discount}% discount
              </span>
            )}
          </LinearLayout>
          <LinearLayout
            className="ms-3"
            gap={2}
            margin={0}
            orientation="vertical"
          >
            <div
              style={{
                fontSize: "12px",
                color: product?.stock > 0 ? "green" : "red",
              }}
            >
              {product?.stock > 0
                ? `Available in stock (Only ${product?.stock} left.)`
                : `non-existent`}
            </div>
          </LinearLayout>
        </LinearLayout>
      </LinearLayout>
      {/* <div className="buy-bar">
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => {
                e.stopPropagation();
                addToCart(product._id || product.id);
              }}
            >
             Add To Cart
            </button>
          </div> */}
      {/* <div className="buy-bar">
        <div className="price">${fmt(product.price)}</div>
        <button>Add to Card</button>
      </div> */}
     
    </div>
     <Footer />
     <LinearLayout margin={3}></LinearLayout>
    </>
  );
};

export default MobileProductDetail;

